var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#contact{background-image:url(" + escape(require("../../../src/assets/images/contact-bg.jpg")) + ")}.contact___description{color:#fff}#contact .form-control{border:none;border-radius:0;box-shadow:none;margin-bottom:20px}#contact input[type=button]:hover{background:#107db6}#contact input[type=button]{background:#28a7e9;color:#fff;font-weight:700;transition:all .3s ease}#contact input{height:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c9fb82c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contact/contact.vue
// module id = 22
// module chunks = 0